import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';
import logo from '../images/stacktalent-708X214.jpg';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);

        const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/auth/reset-password`,
        });

        if (resetError) {
            setError(resetError.message);
        } else {
            setMessage(`Password reset instructions have been sent to ${email}. Please check your inbox.`);
        }

        setLoading(false);
    };

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center"
            style={{ background: 'var(--tu-gradient-nav)' }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4">
                        <div className="card border-0 p-4" style={{ borderRadius: '16px', boxShadow: 'var(--tu-shadow-hover)' }}>
                            <div className="text-center mb-4">
                                <img src={logo} alt="Stacktalent" style={{ height: '36px', objectFit: 'contain' }} />
                            </div>

                            <h5 className="fw-bold mb-1" style={{ color: 'var(--tu-navy-900)' }}>Reset your password</h5>
                            <p className="small mb-4" style={{ color: 'var(--tu-text-muted)' }}>
                                Enter your email and we'll send you a reset link.
                            </p>

                            {error && <div className="alert alert-danger py-2 small mb-3">{error}</div>}
                            {message && <div className="alert alert-success py-2 small mb-3">{message}</div>}

                            {!message && (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-4">
                                        <label className="form-label fw-semibold small" style={{ color: 'var(--tu-text-primary)' }}>
                                            Email address
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            autoComplete="email"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn w-100 fw-semibold py-2 mb-3"
                                        style={{
                                            background: 'var(--tu-navy-900)',
                                            color: 'var(--tu-text-on-dark)',
                                            borderRadius: '8px',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading && <span className="spinner-border spinner-border-sm me-2" />}
                                        Send Reset Link
                                    </button>
                                </form>
                            )}

                            <div className="text-center">
                                <Link to="/login" className="small text-decoration-none" style={{ color: 'var(--tu-cyan-600)' }}>
                                    Back to Sign In
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
